
import { defineComponent, ref, PropType, toRefs } from 'vue'

import { IdfIcon } from '@invivodf/ui-kit'
import PLink from '@invivodf/common/src/application/presenters/PLink/PLink.vue'

interface NavigationLink {
  icon: string
  label: string
  link?: { name: string }
  subMenu?: { label: string; link: { name: string } }[]
  // Opt-in, sub-menu entries only: the trigger opens this page while unfolding the sub-menu.
  parentLink?: { name: string }
}

export default defineComponent({
  name: 'PMainNavigation',
  components: {
    IdfIcon,
    PLink,
  },
  props: {
    hasVisibleLabels: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    links: {
      type: Array as PropType<NavigationLink[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { links } = toRefs(props)
    const activeIndex = ref<number | null>(null)
    const activeSubIndex = ref<number | null>(null)
    const openSubMenus = ref<Record<number, boolean>>({})

    const toggleSubMenu = (index: number) => {
      openSubMenus.value = {
        ...openSubMenus.value,
        [index]: activeIndex.value !== index ? true : !openSubMenus.value[index],
      }
      emit('submenu-clicked')
    }

    // The link travels with the event: a layout may need to tell a menu click on the route already shown.
    const onLinkClick = (index: number) => {
      emit('clicked', links.value[index].link)
      activeIndex.value = index
      activeSubIndex.value = null
    }
    const onSubLinkClick = (parentIndex: number, subIndex: number) => {
      emit('clicked', links.value[parentIndex].subMenu?.[subIndex]?.link)
      activeIndex.value = parentIndex
      activeSubIndex.value = subIndex
    }
    const onSubMenuClicked = (index: number) => {
      toggleSubMenu(index)
      const { parentLink } = links.value[index]
      if (parentLink) {
        emit('clicked', parentLink)
        activeIndex.value = index
        activeSubIndex.value = null
      } else if (links.value[index].subMenu?.length === 1) onSubLinkClick(index, 0)
    }

    return {
      activeIndex,
      activeSubIndex,
      openSubMenus,
      toggleSubMenu,
      onLinkClick,
      onSubLinkClick,
      onSubMenuClicked,
    }
  },
})
